import { cn } from "@/lib/utils";
import { getLevelInfo } from "@/lib/levelUtils";
import { useTranslation } from "react-i18next";

interface LevelBadgeProps {
  level: number;
  size?: "sm" | "md" | "lg";
  showLabel?: boolean;
  className?: string;
}

export default function LevelBadge({ level, size = "md", showLabel = false, className }: LevelBadgeProps) {
  const { t } = useTranslation("common");
  const info = getLevelInfo(level);
  const localizedLabel = t(`levelInfo.${info.labelKey}`, info.label);

  const sizeClasses = {
    sm: "h-6 w-6 text-xs",
    md: "h-10 w-10 text-lg",
    lg: "h-14 w-14 text-2xl",
  };

  return (
    <div className={cn("flex items-center gap-2", className)}>
      <div
        className={cn(
          "flex items-center justify-center rounded-full ring-2 font-bold",
          info.bgClass,
          info.textClass,
          sizeClasses[size]
        )}
      >
        {level}
      </div>
      {showLabel && (
        <div className="flex flex-col">
          <span className={cn("font-semibold text-sm", info.textClass)}>{localizedLabel}</span>
          <span className="text-xs text-muted-foreground">{t("levelNofM", { n: level })}</span>
        </div>
      )}
    </div>
  );
}
